export const formatUsername = (name: string, type: string) => {
  switch (type) {
    case 'instagram':
    case 'twitter':
      return `@${name}`
    default:
      return name
  }
}
